import React from "react";

const FlowMob = () => {
  return (
    <>
      <div className="flowMobHolder">
        <div className="flowmobBox">

          {/* COMPANY 1: RESIDENT INTERFACE */}
          <div className="flowmobCard" style={{ borderLeftColor: "#2d234a" }}>
            <div className="title">
              Resident Interface / Hunter Warfield
            </div>
            <div className="subtitle">
              Full Stack Engineer <span>(Aug 2025 – Present)</span>
            </div>
            <div className="content" style={{ fontSize: "0.85rem", color: "#666" }}>
              • Full-Time Employee under Resident Interface (Feb 2026 – Present)<br/>
              • Contract based work with Hunter Warfield (Aug 2025 – Feb 2026)
            </div>
            <div className="content">
              Contributed to Resident Interface's upcoming <strong>Unified Platform</strong> — an end-to-end delinquency management system covering legal notices, rent litigation, writ of eviction processing, and final debt collection.
            </div>
          </div>

          <div className="flowmobCard">
            <div className="title">Systems & Workflow Automation</div>
            <div className="content">
              • <strong>Automated Workflow Pipeline:</strong> Implemented real-time task routing and execution across eviction case lifecycles among internal staff, notaries, attorneys, and system background workers.
            </div>
            <div className="content">
              • <strong>Nutrient PDF Editor:</strong> Integrated document template management for automated generation of legal notices, court dockets, hearing documents, and court filings.
            </div>
          </div>


          {/* COMPANY 2: TCS */}
          <div className="flowmobCard" style={{ borderLeftColor: "#2d234a" }}>
            <div className="title">
              Tata Consultancy Services (TCS)
            </div>
            <div className="subtitle">
              Systems Engineer <span>(Jun 2021 – Jul 2025)</span>
            </div>
            <div className="content">
              4 years of experience as a <strong>Full Stack Web Developer</strong> at TCS delivering high-performance web applications across monolithic, microservices, and event-driven architectures.
            </div>
          </div>

          <div className="flowmobCard">
            <div className="title">Clients in TCS</div>
            <div>
              <div className="subtitle">
                1. College Advisor <span>(Feb 2024 – Jul 2025)</span>
              </div>
              <div className="content">
                Ed-tech platform helping over 5,000+ students achieve college admissions.
              </div>
            </div>
            <div>
              <div className="subtitle">
                2. Condé Nast <span>(Jun 2021 – Jan 2024)</span>
              </div>
              <div className="content">
                Global media player reaching 72M+ consumers across Vogue, GQ, Architectural Digest, CNTraveller, Vanity Fair, etc.
              </div>
            </div>
          </div>

          <div className="flowmobCard">
            <div className="title">Algorithmic Features & Impact</div>
            <div className="content">
              • <strong>Smart Match Engine:</strong> Built multi-criteria scoring algorithm matching prospective students to advisors — <strong>scaling premium student conversions from 68% to 92%</strong>.
            </div>
            <div className="content">
              • <strong>Smart Advisor Filter:</strong> Built pitch-prep tools for sales teams prior to discovery calls.
            </div>
          </div>

          <div className="flowmobCard">
            <div className="title">Fintech & Payments</div>
            <div className="content">
              • Integrated & maintained payment solutions across <strong>Stripe, Juspay, Razorpay, and PayPal</strong>.
            </div>
            <div className="content">
              • Implemented recurring subscription & auto-renewal payment pipelines for Condé Nast India publications with dashboard controls.
            </div>
          </div>

          <div className="flowmobCard">
            <div className="title">Infrastructure & Growth Integrations</div>
            <div className="content">
              • Integrated <strong>Meta/Facebook Conversion API</strong> for targeted ad campaigns.
            </div>
            <div className="content">
              • Integrated <strong>Google MakeStories</strong> with WordPress publishing pipelines.
            </div>
            <div className="content">
              • Migrated legacy server and PHP WordPress environments with <strong>under 5 minutes of downtime</strong>.
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default FlowMob;
